import React from 'react';
import { Box, Typography } from '@mui/material';
import { useDashboardData } from './DashboardProvider';

const Greeting = () => {
  const { greetingText } = useDashboardData();

  return (
    <Box>
      <Typography
        variant="h1"
        sx={{
          background:
            'linear-gradient(135deg, #0F766E 0%, #0D9488 45%, #14B8A6 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          mb: 0.5,
        }}
      >
        {greetingText}
      </Typography>
      <Typography
        sx={{
          color: '#64748B',
          fontSize: '1.05rem',
        }}
      >
        Track your impact and keep up the momentum.
      </Typography>
    </Box>
  );
};

export default Greeting;
